import React, { useContext, useEffect, useState } from "react";
import "../Assets/css/brand.css";
import InfluencerCardList from "../Common/InfluencerCardList";
import Search from "../Assets/Img/search.png";
import Heart from "../Assets/Img/Heart.svg";
import HeartDark from "../Assets/Img/HeartDark.svg";
import Filter from "../Assets/Img/Filter.png";
import Sort from "../Assets/Img/sort.png";
import SortDown from "../Assets/Img/sort.png"; // Add a descending icon if needed
import View from "../Assets/Img/View.png";
import tableicon from "../Assets/Img/tableicon.png";
import InfluencerGridList from "../Common/InfluencerGridList";
import axiosMain from "./../http/axiosMain";
import users from "../Assets/Img/users.png";
import userprofileimg from "../Assets/Img/userprofileimg.png";
import ProfileImg from "../Assets/Img/Imgs.png";
import { useNavigate } from "react-router-dom";
import { Modal, Form, Dropdown } from "react-bootstrap";
import instagram from "../Assets/Img/Instagram.svg";
import youtube from "../Assets/Img/YouTube.svg";
import facebook from "../Assets/Img/facebook.png";
import LinkedIn from "../Assets/Img/LinkedIn.png";
import Snaphat from "../Assets/Img/SnapChat.jpg";
import { FaEdit } from "react-icons/fa"; // Import Edit Icon
import { FaPlus } from "react-icons/fa";
import { GlobalContext } from "../../utils/GlobalContext";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css"; // Don't forget this import for styles
import Right from "../Assets/Img/Right.png";
import Left from "../Assets/Img/left.png";
import emptyfavorite from "../Assets/Img/insights.svg";
import { Box, Chip, Tooltip } from "@mui/material";

// const initialData = [
//   {
//     id: 1,
//     name: "John Morgan",
//     category: "Photography",
//     engagement: "4%",
//     audience: "120k",
//     genderStats: { male: "63%", female: "30%", others: "7%" },
//     image: "https://via.placeholder.com/50",
//   },
//   {
//     id: 2,
//     name: "Alice Smith",
//     category: "Fashion",
//     engagement: "5%",
//     audience: "90k",
//     genderStats: { male: "40%", female: "50%", others: "10%" },
//     image: "https://via.placeholder.com/50",
//   },
//   {
//     id: 3,
//     name: "Tom Brown",
//     category: "Travel",
//     engagement: "3%",
//     audience: "110k",
//     genderStats: { male: "70%", female: "20%", others: "10%" },
//     image: "https://via.placeholder.com/50",
//   },
//   {
//     id: 4,
//     name: "Emma Wilson",
//     category: "Lifestyle",
//     engagement: "6%",
//     audience: "150k",
//     genderStats: { male: "50%", female: "45%", others: "5%" },
//     image: "https://via.placeholder.com/50",
//   },
//   {
//     id: 5,
//     name: "Liam Johnson",
//     category: "Gaming",
//     engagement: "7%",
//     audience: "80k",
//     genderStats: { male: "80%", female: "15%", others: "5%" },
//     image: "https://via.placeholder.com/50",
//   },
// ];

function BrandDetailsadminDashboard({ show }) {
  const { isLogdin, setisLogdin } = useContext(GlobalContext);
  const [showEditProfileModal, setShowEditProfileModal] = useState(false);
  const [showEditOptions, setShowEditOptions] = useState(false);
  // const [influencers, setInfluencers] = useState();
  const [originalInfluencers, setOriginalInfluencers] = useState([]);
  const [loading, setLoading] = useState(true);
  const { userData, setUserData } = useContext(GlobalContext);
  const [userEmail, setUserEmail] = useState("");
  const [isHovered, setIsHovered] = useState(false);
  const [isrefreshModalOpen, setIsModalOpen] = useState(
    !localStorage.getItem("brand_name")
  ); // Prevent opening if brand_name exists

  const [searchTerm, setSearchTerm] = useState("");

  const [filteredData, setFilteredData] = useState();
  const [selectedFilters, setSelectedFilters] = useState({});
  const [otp, setOtp] = useState(true); // Assume OTP is true initially
  const [step1, setStep1] = useState(true);

  // genere sorting
  const [sortDirectionGenre, setSortDirectionGenre] = useState("asc");
  const [influencers, setInfluencers] = useState([]);

  const [isFavoritesFiltered, setIsFavoritesFiltered] = useState(false);
  const [profileDetails, setProfileDetails] = useState({
    logo: "",
    name: "",
    phone: sessionStorage.getItem("phone_no") || "",
    email: "",
    address: "",
    pin: "",
    city: "",
  });
  const [profileSetupDetails, setProfileSetupDetails] = useState({
    bio: "",
    website: "",
    socialLinks: [
      { platform: "Instagram", url: "" },
      { platform: "YouTube", url: "" },
      { platform: "Facebook", url: "" },
      { platform: "LinkedIn", url: "" },
    ],
  });
  const handleAddSnapchat = () => {
    setProfileSetupDetails((prevState) => ({
      ...prevState,
      socialLinks: [
        ...prevState.socialLinks,
        { platform: "Snapchat", url: "" },
      ],
    }));
  };
  const getPlatformIcon = (platform) => {
    switch (platform) {
      case "Instagram":
        return instagram;
      case "YouTube":
        return youtube;
      case "Facebook":
        return facebook;
      case "LinkedIn":
        return LinkedIn;
      case "Snapchat":
        return Snaphat;
      default:
        return null;
    }
  };

  // genere sorting

  const [selectedCategories, setSelectedCategories] = useState([]);
  // const [selectedCity, setSelectedCity] = useState("");

  // const [ModalOpen, setIsModalOpen] = useState(false); // store brand nameeee

  // const categories = ["Fashion", "Tech", "Food", "Beauty", "Fitness"];
  const [categories, setCategories] = useState([]); // Initialize categories as an empty array
  const [recordsPerPages, setRecordsPerPages] = useState(10); // Set default records per page

  // for clear modal
  const resetAllFields = () => {
    setProfileDetails({
      logo: null,
      logoPreview: null,
      name: "",
      phone: "",
      email: "",
      address: "",
      pin: "",
    });

    setProfileSetupDetails({
      website: "",
      socialLinks: [{ platform: "", link: "" }],
      bio: "",
    });

    setSelectedCategories([]);
    setSelectedStates([]);
    setSelectedCity("");
  };

  // store brand nameeee
  useEffect(() => {
    // Check if brand_name is stored in localStorage
    if (!localStorage.getItem("brand_name")) {
      setIsModalOpen(true);
    }
  }, []);

  // const states = [
  //   "Maharashtra",
  //   "Karnataka",
  //   "Tamil Nadu",
  //   "Uttar Pradesh",
  //   "Rajasthan",
  // ];
  // const cities = ["Mumbai", "Bengaluru", "Chennai", "Delhi", "Kolkata"];

  useEffect(() => {
    if (otp) {
      setShowEditProfileModal(true);
    }
  }, [otp]);

  /**Use this useeffect for show signup user email in modal */
  useEffect(() => {
    const email = sessionStorage.getItem("email"); // Retrieve email from session
    if (email) {
      setUserEmail(email);
      setProfileDetails((prevDetails) => ({
        ...prevDetails,
        email: email, // Update profileDetails with stored email
      }));
    }
  }, [setProfileDetails]);

  useEffect(() => {
    const phoneNo = sessionStorage.getItem("phone_no");
    if (phoneNo) {
      setProfileDetails((prevDetails) => ({
        ...prevDetails,
        phone: phoneNo, // Ensure phone is updated in state
      }));
    }
  }, [setProfileDetails]); // Trigger when modal opens

  const handleCloseEditProfileModal = () => {
    setShowEditProfileModal(false);
  };
  const handleCheckboxChange = (category) => {
    setSelectedCategories((prevSelectedCategories) => {
      if (prevSelectedCategories.includes(category)) {
        // If category is already selected, remove it
        return prevSelectedCategories.filter((item) => item !== category);
      } else {
        // Otherwise, add the category to the selected list
        return [...prevSelectedCategories, category];
      }
    });
  };

  // Toggle the dropdown visibility
  const toggleDropdown = () => {
    setOpenDropdown((prevState) => !prevState);
  };
  const handleNext = () => {
    setStep1(!step1);
  };

  const [currentPage, setCurrentPage] = useState(1);

  const navigate = useNavigate();
  const [favorites, setFavorites] = useState(
    new Set(JSON.parse(localStorage.getItem("favoriteInfluencers")) || [])
  );

  // for states
  const [states, setStates] = useState([]);
  const [selectedStates, setSelectedStates] = useState("");
  const [openDropdown, setOpenDropdown] = useState(null);

  // for city
  const [cities, setCities] = useState([]);
  const [selectedCity, setSelectedCity] = useState([]);
  // ✅ Fetch Cities based on State ID
  const [isFilterPopupOpen, setIsFilterPopupOpen] = useState(false);
  const [openModal, setOpenModal] = useState(false);

  const [totalInfluencers, setTotalInfluencers] = useState(0);
  const [selectedTab, setSelectedTab] = useState("home");
  // const [favorites, setFavorites] = useState(new Set());
  const [sortParams, setSortParams] = useState({
    isEngagementSortedAsc: false,
    isEngagementSortedDesc: false,
    isFollowersSortedAsc: false,
    isFollowersSortedDesc: false,
  });
  const handleSortClick = (field) => {
    setSortParams((prevState) => {
      const currentAsc = prevState[`is${field}SortedAsc`];
      const currentDesc = prevState[`is${field}SortedDesc`];

      return {
        isEngagementSortedAsc:
          field === "Engagement" ? !currentAsc && !currentDesc : false,
        isEngagementSortedDesc: field === "Engagement" ? currentAsc : false,
        isFollowersSortedAsc:
          field === "Followers" ? !currentAsc && !currentDesc : false,
        isFollowersSortedDesc: field === "Followers" ? currentAsc : false,
      };
    });
  };

  const [selectedEngagementFilters, setSelectedEngagementFilters] = useState(
    new Set()
  );
  const [sortDirectionEngagement, setSortDirectionEngagement] = useState("asc");
  const [sortDirectionFollowers, setSortDirectionFollowers] = useState("asc");

  const handleSearch = async (e) => {
    setSearchTerm(e.target.value);
  };
  const toggleFilterPopup = () => {
    setIsFilterPopupOpen(!isFilterPopupOpen);
    if (!isFilterPopupOpen) {
      setTotalInfluencers(influencers?.length); // Show full count when filter opens
    }
  };

  const handleClearFilters = () => {
    setSelectedEngagementFilters(new Set());
    setFilteredData(influencers); // Reset data
    setTotalInfluencers(influencers?.length); // Reset count
  };

  const [isLikedFilter, setIsLikedFilter] = useState([]);

  // useEffect(() => {
  //   const fetchData = async () => {
  //     if (!searchTerm) {
  //       fetchInfluencers();
  //       return;
  //     }

  //     setLoading(true);

  //     try {
  //       const response = await axiosMain.get(
  //         `/api/v1/search-influencer?search=${searchTerm}`
  //       );
  //       setInfluencers(response.data.influencers); // Assuming the response contains the data directly
  //     } catch (error) {
  //       console.error("Error fetching data:", error);
  //     } finally {
  //       setLoading(false);
  //     }
  //   };

  //   // Debounce to avoid making too many requests on every keystroke
  //   const timer = setTimeout(() => fetchData(), 500);

  //   // Cleanup on searchTerm change
  //   return () => clearTimeout(timer);
  // }, [searchTerm]);

  const handleEngagementFilterChange = (range) => {
    setSelectedEngagementFilters((prevFilters) => {
      const newFilters = new Set(prevFilters);
      if (newFilters.has(range)) {
        newFilters.delete(range);
      } else {
        newFilters.add(range);
      }
      return newFilters;
    });
  };

  const [grideView, setgrideView] = useState(false);
  const [totalPages, setTotalPages] = useState(1);

  const toggleView = () => {
    setgrideView(!grideView);
  };
  const applyFilters = () => {
    if (Object.keys(selectedFilters)?.length === 0) {
      setInfluencers(originalInfluencers); // Reset to original list
      return;
    }

    let filtered = [...originalInfluencers];

    Object.keys(selectedFilters).forEach((category) => {
      const selectedValues = Array.from(selectedFilters[category]);

      if (selectedValues?.length === 0) return;

      if (category === "home") {
        filtered = filtered.filter((inf) =>
          selectedValues.some((range) => {
            const [min, max] = range.split("-").map(Number);
            return inf.engagement >= min && inf.engagement <= max;
          })
        );
      }

      if (category === "menu1") {
        filtered = filtered.filter((inf) =>
          selectedValues.some((range) => {
            const [min, max] = range
              .replace(/k/g, "000")
              .split(" - ")
              .map(Number);
            return inf.reach >= min && inf.reach <= max;
          })
        );
      }

      if (category === "menu2") {
        filtered = filtered.filter((inf) =>
          selectedValues.includes(inf.language)
        );
      }

      if (category === "menu3") {
        filtered = filtered.filter((inf) =>
          selectedValues.some((range) => {
            const [min, max] = range
              .replace(/k/g, "000")
              .replace(/M/g, "000000")
              .split("-")
              .map(Number);
            return inf.followers >= min && inf.followers <= max;
          })
        );
      }

      if (category === "menu6") {
        filtered = filtered.filter((inf) => selectedValues.includes(inf.city));
      }
    });

    setInfluencers(filtered);
  };

  const handleSortEngagement = () => {
    setInfluencers((prevData) => {
      // Make sure to clone the array to avoid mutating the original data
      const sortedData = [...prevData].sort((a, b) => {
        // Attempt to parse the engagement values as floats
        const engagementA = parseFloat(a.engagement);
        const engagementB = parseFloat(b.engagement);

        // Check if both are valid numbers
        if (isNaN(engagementA) && isNaN(engagementB)) {
          return 0; // Both are NaN, no change in their order
        }
        if (isNaN(engagementA)) {
          // If A is NaN, move it to the bottom or top based on the sort direction
          return sortDirectionEngagement === "asc" ? 1 : -1;
        }
        if (isNaN(engagementB)) {
          // If B is NaN, move it to the bottom or top based on the sort direction
          return sortDirectionEngagement === "asc" ? -1 : 1;
        }

        // If both are valid numbers, sort them numerically based on direction
        return sortDirectionEngagement === "asc"
          ? engagementA - engagementB
          : engagementB - engagementA;
      });

      return sortedData;
    });

    // Toggle sort direction after each sort
    setSortDirectionEngagement((prev) => (prev === "asc" ? "desc" : "asc"));
  };

  const handleSortFollowers = () => {
    setSortDirectionFollowers((prev) => {
      const newDirection = prev === "asc" ? "desc" : "asc";

      setInfluencers((prevData) => {
        const sortedData = [...prevData].sort((a, b) => {
          const followersA = parseFloat(a.followers);
          const followersB = parseFloat(b.followers);

          if (isNaN(followersA) && isNaN(followersB)) return 0;
          if (isNaN(followersA)) return newDirection === "asc" ? 1 : -1;
          if (isNaN(followersB)) return newDirection === "asc" ? -1 : 1;

          return newDirection === "asc"
            ? followersA - followersB
            : followersB - followersA;
        });

        return sortedData;
      });

      return newDirection;
    });
  };

  // Handle page change when the user selects a page from the dropdown
  const handlePageChange = (event) => {
    const selectedPage = Number(event.target.value);
    setCurrentPage(selectedPage); // Update current page state
  };
  const [flagBrandUser, setFlagBrandUser] = useState(true); // Manage flag state
  const handleflagBrandUser = () => {
    setFlagBrandUser(false);
    navigate("/admin-brand-information");
  };
  const fetchInfluencers = async () => {
    setLoading(true);
    try {
      const response = await axiosMain.get("/api/admin/all_user_data", {
        params: { flag_brand_user: flagBrandUser },
      });

      if (!response.data.status) {
        throw new Error("Failed to fetch user data");
      }

      const userData = response.data.data;

      // Filter based on 'isFavoritesFiltered'
      const filteredUserData = userData;

      // Calculate total records
      const totalRecords = filteredUserData.length;

      // Set total number of pages based on records per page
      setTotalPages(Math.ceil(totalRecords / recordsPerPages));

      // Set the original user data list
      setOriginalInfluencers(filteredUserData);

      // Slice the user data based on current page and records per page
      const userDataForCurrentPage = filteredUserData.slice(
        (currentPage - 1) * recordsPerPages,
        currentPage * recordsPerPages
      );

      setInfluencers(userDataForCurrentPage); // Update state with sliced user data
    } catch (error) {
      console.error("Error fetching user data:", error);
    } finally {
      setLoading(false);
    }
  };

  const [activeTab, setActiveTab] = useState("all"); // Default active tab

  useEffect(() => {
    fetchInfluencers();
  }, [currentPage, recordsPerPages]);

  // Go to the next page
  const goToNextPage = () => {
    setCurrentPage((prevPage) => Math.min(prevPage + 1, totalPages)); // Go to next page
  };

  // Go to the previous page
  const goToPreviousPage = () => {
    setCurrentPage((prevPage) => Math.max(prevPage - 1, 1)); // Go to previous page
  };

  const handleRecordsPerPageChange = (event) => {
    setRecordsPerPages(Number(event.target.value)); // Corrected the function name here
    setCurrentPage(1); // Reset to first page when records per page changes
  };

  // Handle tab change
  const handleTabChange = (tab) => {
    setActiveTab(tab);
    setCurrentPage(1); // Reset to first page when switching tabs
  };

  if (loading) {
    return <div>Loading...</div>;
  }
  const handleReachFilterChange = (range) => {
    console.log(`Selected Reach range: ${range}`);
    // Add logic to update the state for Reach filters
  };

  const formatFollowers = (followers) => {
    if (followers >= 1000000) {
      return (followers / 1000000).toFixed(1) + "M"; // Format as "10.5M"
    } else if (followers >= 1000) {
      return (followers / 1000).toFixed(1) + "k"; // Format as "16.3k"
    } else {
      return followers; // No conversion, just return the number
    }
  };
  const filterOptions = {
    home: {
      label: "Engagement",
      options: [
        { value: "2-4", label: "2% - 4%" },
        { value: "5-7", label: "5% - 7%" },
        { value: "8-10", label: "8% - 10%" },
      ],
    },
    menu1: {
      label: "Reach",
      options: [
        { value: "0 - 100k", label: "(0 - 100k)" },
        { value: "100k - 200k", label: "(100k - 200k)" },
        { value: "200k - 200k", label: "(200k - 300k)" },
        { value: "300k - 400k", label: "(300k - 400k)" },
        { value: "400k - 500k", label: "(400k - 500k)" },
        { value: "500k - 600k", label: "(500k - 600k)" },
        { value: "600k - 700k", label: "(600k - 700k)" },
        { value: "700k - 800k", label: "(700k - 800k)" },
        { value: "800k - 900k", label: "(800k - 900k)" },
        { value: "900k+", label: "900k+" },
      ],
    },
    menu2: {
      label: "Language",
      options: [
        { value: "english", label: "English" },
        { value: "Hindi", label: "Hindi" },
        { value: "Gujarati", label: "Gujarati" },
        { value: "Punjabi", label: "Punjabi" },
        { value: "Telugu", label: "Telugu" },
        { value: "Tamil", label: "Tamil" },
        { value: "Malayalam", label: "Malayalam" },
        { value: "Kannada", label: "Kannada" },
      ],
    },
    menu3: {
      label: "Followers",
      options: [
        { value: "10k-100k", label: "1k - 10k" },
        { value: "100k-300k", label: "100k-300k" },
        { value: "300k-500k", label: "300k-500k" },
        { value: "500k-700k", label: "500k-700k" },
        { value: "700k-900k", label: "700k-900k" },
        { value: "900k-1M", label: "900k-1M" },
        { value: "1M-3M", label: "1M-3M" },
        { value: "3M+", label: "3M+" },
      ],
    },
    menu4: {
      label: "Genre",
      options: [
        { value: "Art & Photography", label: "Art & Photography" },
        {
          value: "Business & Entrepreneurship",
          label: "Business & Entrepreneurship",
        },
        { value: "Entertainment", label: "Entertainment" },
        { value: "Education", label: "Education" },
        {
          value: "Fitness, Fashion & Beauty",
          label: "Fitness, Fashion & Beauty",
        },
        { value: "Lifestyle & Travel", label: "Lifestyle & Travel" },
        { value: "Tech & Gaming", label: "Tech & Gaming" },
        { value: "Others", label: "Others" },
      ],
    },
    menu5: {
      label: "Age",
      options: [
        { value: "13-17", label: "13-17" },
        { value: "18-24", label: "18-24" },
        { value: "25-34", label: "25-34" },
        { value: "35-44", label: "35-44" },
        { value: "45-54", label: "45-54" },
        { value: "55-64", label: "55-64" },
        { value: "65+", label: "65+" },
      ],
    },
    menu6: {
      label: "City",
      options: [
        { value: "Mumbai", label: "Mumbai" },
        { value: "Delhi", label: "Delhi" },
        { value: "Bangalore", label: "Bangalore" },
        { value: "Chennai", label: "Chennai" },
        { value: "Kolkata", label: "Kolkata" },
        { value: "Jaipur", label: "Jaipur" },
        { value: "Hyderabad", label: "Hyderabad" },
        { value: "Other Cities", label: "Other Cities" },
      ],
    },
  };
  const handleFilterChange = (category, value) => {
    setSelectedFilters((prevFilters) => {
      const newFilters = { ...prevFilters };

      if (!newFilters[category]) {
        newFilters[category] = new Set(); // Ensure category exists
      } else {
        newFilters[category] = new Set(newFilters[category]); // Clone the Set
      }

      if (newFilters[category].has(value)) {
        newFilters[category].delete(value);
        if (newFilters[category].size === 0) delete newFilters[category]; // Remove empty category
      } else {
        newFilters[category].add(value);
      }

      return { ...newFilters }; // Return new object for state update
    });
  };
  const resetFilters = () => {
    setSelectedFilters({}); // Clear all selected filters
    setSelectedTab(Object.keys(filterOptions)[0]); // Reset to first tab (optional)
    setInfluencers(originalInfluencers); // Restore full influencer list
  };

  return (
    <>
      <div>
        <div className="d-flex justify-content-between align-items-center">
          <div style={{ display: "flex", gap: "20px" }}>
            <h5
              className="Title"
              style={{
                color: "#676767",
                cursor: "pointer",
                paddingRight: "20px",
                fontSize: "30px",
              }}
              onMouseEnter={(e) => {
                e.target.style.textDecoration = "underline";
                e.target.style.color = "#6b8e76";
              }}
              onMouseLeave={(e) => {
                e.target.style.textDecoration = "none";
                e.target.style.color = "#676767";
              }}
              onClick={() => navigate("/contactsdashboard")}
            >
              Influencers
            </h5>

            <h5
              className="Title"
              style={{
                color: "#676767",
                cursor: "pointer",
                paddingRight: "20px",
                fontSize: "30px",
              }}
              onMouseEnter={(e) => {
                e.target.style.textDecoration = "underline";
                e.target.style.color = "#6b8e76";
              }}
              onMouseLeave={(e) => {
                e.target.style.textDecoration = "none";
                e.target.style.color = "#676767";
              }}
              onClick={() => handleflagBrandUser()}
            >
              Brand
            </h5>
          </div>

          <div className="SearchFilterSection">
            <div className="SearchInput">
              <img src={Search} className="img-fluid" alt="Search Icon" />
              <input
                type="text"
                className="form-control"
                placeholder="Search for Influencer, Genre"
                value={searchTerm}
                onChange={(e) => handleSearch(e)}
                autoFocus
              />
            </div>
          </div>
        </div>

        <div className="row g-0">
          <div className="TableBox">
            <div className="TableBox">
              <div className="InfluancerCardView Shorting influencer-list">
                <div className="influencer-card">
                  <div
                    className="InfluencerProfile"
                    style={{ marginLeft: "-15px" }}
                  >
                    Influencers
                  </div>
                  {/* Sort Button for Genre */}
                  <div
                    className="InfluencerGenre"
                    style={{
                      // marginLeft: "-68px",
                      // paddingLeft: "116px",
                      cursor: "pointer",
                    }}
                  >
                    Genre{" "}
                  </div>
                  <div
                    className="InfluencerGenre"
                    style={{ marginLeft: "-120px", paddingLeft: "184px" }}
                  >
                    Email
                  </div>
                  {/* <div className="InfluencerGenre">Cpp</div> */}

                  <div
                    className="engagement"
                    // onClick={() => handleSortEngagement()}
                    style={{ marginLeft: "56px", paddingLeft: "11px" }}
                  >
                    Contact No
                  </div>

                  <div
                    className="InfluencerFollowes"
                    // onClick={handleSortFollowers}
                    style={{ marginLeft: "-91px", paddingLeft: "84px" }}
                  >
                    State
                  </div>

                  {/* <div
                    className="InfluencerEngagement"
                    style={{ marginRight: "66px" }}
                  >
                    Last Login Date
                  </div> */}
                </div>
              </div>

              <div className="InfluancerCardView">
                <div
                  className="influencer-list"
                  // onClick={() => navigate("/influencerstats")}
                >
                  {influencers.map((influencer) => (
                    <div key={influencer.user_id} className="influencer-card">
                      <div
                        className="InfluencerProfile"
                        style={{ marginLeft: "-22px" }}
                      >
                        <img
                          src={ProfileImg}
                          className="img-fluid"
                          alt={influencer.influencer_name}
                        />
                        <h4>{influencer.influencer_name}</h4>
                      </div>

                      <div
                        className="InfluencerGenre"
                        style={{
                          marginLeft: "-21px",
                          paddingRight: "38px",
                        }}
                      >
                        {influencer?.category?.length ? (
                          (() => {
                            const category = influencer.category;

                            return (
                              <Box
                                display={"flex"}
                                gap={1}
                                alignItems={"center"}
                              >
                                {category?.[0]}{" "}
                                {category.length > 1 ? (
                                  <Tooltip
                                    title={category
                                      .slice(1)
                                      .map((i) => i)
                                      .filter(Boolean)
                                      .join(", ")}
                                    placement="bottom"
                                    sx={{
                                      "& .MuiTooltip-tooltip": {
                                        fontFamily:
                                          "Poppins, sans-serif !important",
                                        fontSize: "14px",
                                        letterSpacing: "0.5px",
                                      },
                                    }}
                                  >
                                    <Chip
                                      sx={{
                                        backgroundColor: "#ccc", // Light grey color
                                        color: "#333", // Dark text for contrast
                                        fontFamily: "Poppins, sans-serif",
                                        cursor: "pointer",
                                      }}
                                      label={`+ ${category.length - 1}`}
                                    />
                                  </Tooltip>
                                ) : (
                                  <></>
                                )}
                              </Box>
                            );
                          })()
                        ) : (
                          <>N/A</>
                        )}
                      </div>

                      <div
                        className="InfluencerGenre"
                        style={{
                          marginLeft: "-68px",
                          paddingRight: "70px",
                        }}
                      >
                        {influencer.email}
                      </div>

                      <div
                        className="engagement"
                        style={{
                          marginLeft: "-36px",
                          paddingLeft: "60px",
                        }}
                      >
                        <p>{influencer.phone_no}</p>
                      </div>

                      <div
                        className="InfluencerFollowes"
                        style={{
                          marginLeft: "-276px",
                          paddingLeft: "238px",
                        }}
                      >
                        {influencer.state}
                      </div>

                      <div
                        className="InfluencerFollowes"
                        style={{
                          marginLeft: "-276px",
                          paddingLeft: "138px",
                        }}
                      >
                        {influencer.date}
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              {/* ToastContainer */}
              <ToastContainer
                position="top-right"
                autoClose={1000} // Auto close after 3 seconds
                hideProgressBar={false}
                closeOnClick
                pauseOnHover
                draggable
                progress={undefined}
              />
            </div>
          </div>

          {favorites.size === 0 && isFavoritesFiltered === true ? (
            <></>
          ) : (
            <div className="pagination-controls">
              <div>
                Show
                <select
                  value={recordsPerPages} // Make sure this is correctly tied to state
                  onChange={handleRecordsPerPageChange}
                  className="pagination-dropdown"
                >
                  {/* Options for records per page */}
                  {[5, 10, 20, 30].map((perPage) => (
                    <option key={perPage} value={perPage}>
                      {perPage}
                    </option>
                  ))}
                </select>
                Entries
              </div>
              <div>
                {currentPage === 1 ? (
                  ""
                ) : (
                  <span
                    onClick={goToPreviousPage}
                    disabled={currentPage === 1}
                    className="pagination-button"
                  >
                    <img src={Left} alt="Left" className="img-fluid" /> Previous
                  </span>
                )}

                {/* Current page display */}
                <input
                  type="text"
                  readOnly
                  value={currentPage}
                  className="text-center"
                />

                {currentPage === totalPages ? (
                  ""
                ) : isFavoritesFiltered === true ? (
                  <>
                    {favorites.size <= 5 ? (
                      <></>
                    ) : (
                      <span
                        onClick={goToNextPage}
                        disabled={currentPage === totalPages}
                        className="pagination-button"
                      >
                        Next{" "}
                        <img src={Right} alt="Right" className="img-fluid" />
                      </span>
                    )}
                  </>
                ) : (
                  <span
                    onClick={goToNextPage}
                    disabled={currentPage === totalPages}
                    className="pagination-button"
                  >
                    Next <img src={Right} alt="Right" className="img-fluid" />
                  </span>
                )}
              </div>
            </div>
          )}
        </div>
        {isFilterPopupOpen && (
          <div className="filter-popup">
            <div className="filter-popup-content">
              <div className="FilterHeader">
                <li className="active">
                  <h6>Filter</h6>
                </li>
                <div className="clear-btn" onClick={() => resetFilters()}>
                  <span>Clear all</span>
                </div>
                <i
                  className="fa fa-times"
                  onClick={() => setIsFilterPopupOpen(false)}
                ></i>
              </div>

              <div className="Filters">
                <ul className="nav nav-pills">
                  {Object.keys(filterOptions).map((key) => (
                    <li
                      key={key}
                      className={selectedTab === key ? "active" : ""}
                    >
                      <a onClick={() => handleTabChange(key)}>
                        {filterOptions[key].label}
                      </a>
                    </li>
                  ))}
                </ul>

                <div className="filter-options">
                  {selectedTab && (
                    <>
                      {filterOptions[selectedTab].options.map((option) => (
                        <div className="form-check" key={option.value}>
                          <input
                            className="form-check-input"
                            type="checkbox"
                            id={`${selectedTab}-${option.value}`}
                            checked={
                              selectedFilters[selectedTab]?.has(option.value) ||
                              false
                            } // Ensures checkbox updates correctly
                            onChange={() =>
                              handleFilterChange(selectedTab, option.value)
                            }
                          />
                          <label
                            className="form-check-label"
                            htmlFor={`${selectedTab}-${option.value}`}
                          >
                            {option.label}
                          </label>
                        </div>
                      ))}
                    </>
                  )}

                  <div className="BtnsGrp">
                    <span>{influencers?.length} Influencers</span>
                    <button
                      type="button"
                      className="btn btn-apply"
                      onClick={() => applyFilters()}
                      style={{ backgroundColor: "#6b8e76", color: "white" }}
                    >
                      Apply Filters
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
}

export default BrandDetailsadminDashboard;
